// extracted by mini-css-extract-plugin
export default {"container":"PostContainer_container__z8zdP"};